(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cocoon-purchase-options"] && !Shopify.designMode) return;
  try {
    (() => {
  const instances = new WeakMap();
  const normalizedMoney = (value) => String(value || '').replace(/\D/g, '');

  function initialize(element) {
    if (instances.has(element)) return;
    const section = element.closest('[data-section-type="product"]');
    const select = section?.querySelector('.single-option-selector[data-index="option1"]');
    const fieldset = element.querySelector('.cocoon-supply-pills');
    const priceContainer = section?.querySelector('.product__price');
    const dataElement = element.querySelector('[data-cocoon-purchase-data]');
    if (!section || !select || !fieldset || !priceContainer || !dataElement) return;
    let data;
    try { data = JSON.parse(dataElement.textContent); } catch { return; }
    const nativeControl = select.closest('.product-form__controls-group');
    const pills = Array.from(fieldset.querySelectorAll('input[type="radio"]'));
    let frame = 0;
    const observerOptions = { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['data-selected-selling-plan', 'value'] };

    function monthlyNode(parent, price) {
      let display = parent.querySelector(':scope > .cocoon-monthly-price');
      if (!display) {
        display = document.createElement('span');
        display.className = 'cocoon-monthly-price';
        const amount = document.createElement('span');
        amount.className = 'cocoon-monthly-price__amount';
        const unit = document.createElement('span');
        unit.className = 'cocoon-monthly-price__unit';
        unit.textContent = ' ' + data.perMonth;
        display.append(amount, unit);
        parent.append(display);
      }
      display.querySelector('.cocoon-monthly-price__amount').textContent = price.monthly;
      display.hidden = false;
      return display;
    }

    function sync() {
      frame = 0;
      if (!element.isConnected) { observer.disconnect(); return; }
      observer.disconnect();
      const variant = data.variants.find(item => item.option === select.value);
      const hasPill = pills.some(pill => pill.value === select.value);
      fieldset.hidden = !hasPill;
      nativeControl?.classList.toggle('cocoon-native-supply-hidden', hasPill);
      pills.forEach(pill => { pill.checked = pill.value === select.value; });
      let selectedPrice = null;
      section.querySelectorAll('.appstle_subscription_wrapper_option').forEach(card => {
        const radio = card.querySelector('input[type="radio"][name="selling_plan"]');
        const wrapper = card.querySelector('.appstle_subscription_amount_wrapper, .appstle_one_time_price_wrapper');
        if (!radio || !wrapper) return;
        const price = radio.value ? variant?.plans.find(plan => plan.id === radio.value) : variant;
        const nativeAmount = wrapper.querySelector('.appstle_subscription_amount');
        const enhance = hasPill && price && variant.months > 1 && normalizedMoney(nativeAmount?.textContent) === normalizedMoney(price.total);
        wrapper.classList.toggle('cocoon-price-monthly', Boolean(enhance));
        if (enhance) {
          monthlyNode(wrapper, price);
          if (radio.checked) selectedPrice = price;
        } else {
          const display = wrapper.querySelector(':scope > .cocoon-monthly-price');
          if (display) display.hidden = true;
        }
      });
      let hero = priceContainer.querySelector(':scope > .cocoon-hero-monthly');
      if (selectedPrice) {
        if (!hero) {
          hero = document.createElement('div');
          hero.className = 'cocoon-hero-monthly';
          hero.setAttribute('aria-live', 'polite');
          hero.setAttribute('aria-atomic', 'true');
          priceContainer.append(hero);
        }
        monthlyNode(hero, selectedPrice);
        hero.hidden = false;
      } else if (hero) hero.hidden = true;
      observer.observe(section, observerOptions);
    }

    function schedule() { if (!frame) frame = requestAnimationFrame(sync); }
    function handleChange(event) {
      if (pills.includes(event.target)) {
        select.value = event.target.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
      schedule();
    }
    function cleanup() {
      observer.disconnect();
      cancelAnimationFrame(frame);
      section.removeEventListener('change', handleChange);
      section.removeEventListener('shopify:section:unload', cleanup);
      window.removeEventListener('pageshow', schedule);
      instances.delete(element);
    }
    const observer = new MutationObserver(schedule);
    instances.set(element, cleanup);
    section.addEventListener('change', handleChange);
    section.addEventListener('shopify:section:unload', cleanup);
    window.addEventListener('pageshow', schedule);
    sync();
  }
  function start() { document.querySelectorAll('[data-cocoon-purchase-options]').forEach(initialize); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', start);
})();
  } catch(e) { console.error(e); }
})();

})();
